import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-sidenav-vendor',
  templateUrl: './sidenav-vendor.component.html',
  styleUrls: ['./sidenav-vendor.component.scss'],
  standalone: false
})
export class SidenavVendorComponent {
  @Output() itemClick = new EventEmitter();

  
  public onItemClick = () => {
    this.itemClick.emit();
  }
}
